export class ConstantsWebservice {
  static readonly GET_FLAECHENQUELLARTEN: string = '/flaechenquellarten';
  static readonly GET_GEBIETSKATEGORIEN: string = '/gebietskategorien';
  static readonly GET_TK_HV_GERUCHSEMISSIONEN: string = '/tk-hv-geruchsemissionen';
  static readonly GET_MINDERUNGSMASSNAHMEN_FLAECHEN: string = '/minderungsmassnahmen-flaechen';
  static readonly GET_MINDERUNGSMASSNAHMEN_TIERKATEGORIEN: string = '/minderungsmassnahmen-tierkategorien';
  static readonly GET_TIERARTEN: string = '/tierarten';
  static readonly GET_TIERKATEGORIEN: string = '/tierkategorien';
  static readonly GET_WINDHAEUFIGKEIT_RICHTLINIENABSTAENDE: string = '/windhaeufigkeit-richtlinienabstaende';
  static readonly POST_ERGEBNIS_PROJEKT: string = '/ergebnis-projekt';
  static readonly POST_GESAMTEMISSION_EMISSIONSSCHWERPUNKT: string = '/gesamtemission-emissionsschwerpunkt';
  static readonly POST_PIC_ABSTAND: string = '/pic-abstand';
  static readonly POST_PIC_WIND: string = '/pic-wind';
  static readonly POST_ERGEBNIS_BETRIEB: string = '/ergebnis-betrieb';

  static readonly POST_USER_PROJEKTE: string = '/user-projekte';
  static readonly POST_USER_PROJEKT_DELETE: string = '/user-projekt-delete';
  static readonly POST_USER_PROJEKT_INSERT: string = '/user-projekt-insert';
  static readonly POST_USER_PROJEKT_COPY: string = '/user-projekt-copy';
  static readonly POST_USER_PROJEKT_LOAD: string = '/user-projekt-load';

  static readonly POST_PROJEKT_SELECT_UEBERSICHT: string = '/projekt-select-uebersicht'; 
  static readonly POST_DOWNLOAD_CSV_WINDDATEN = "/download-csv-winddaten";   
}
